import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostListener, Input, LOCALE_ID, OnInit, ViewChild } from "@angular/core";
import { MatDatepicker } from "@angular/material/datepicker";
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from "@angular/forms";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from "@angular/material/core";

const MY_FORMATS = {
  parse: { dateInput: "DD/MM/YYYY" },
  display: {
    dateInput: "DD/MM/YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};
import { Mode } from "@sharedV11/classes/tarifas/grupostarifas";
import { HttpErrorsService } from "@sharedV11/services/alerts/errors/http-errors.service";
import { SnackbarInfoService } from "@sharedV11/services/alerts/snackbar-info/snackbar-info.service";
import { ConectarApiService } from "@sharedV11/services/api/connection/conectar-api.service";
import { GlobalServicCentros } from "@sharedV11/services/global/global.service centros";
import { GlobalService } from "@sharedV11/services/global/global.service";
import { PanelService } from "@sharedV11/services/panel/panel.service";
import { Translator } from "@sharedV11/services/translator/translator.service";
import { getLocale } from "@sharedV11/utils/factories";
import { DualListComponent } from "angular-dual-listbox";
import { Subject } from "rxjs";
import { takeUntil, first, debounceTime, distinctUntilChanged } from "rxjs/operators";
import moment from "moment";

type MesInfo = { mes: string; anio: number; mesNum: number; label: string };

@Component({
  selector: "app-edit-temporada-tarifas",
  templateUrl: "./edit-temporada-tarifas.component.html",
  styleUrls: ["./edit-temporada-tarifas.component.scss"],
  providers: [
    {
      provide: LOCALE_ID,
      useFactory: getLocale,
      deps: [Translator],
    },
    {
      provide: MAT_DATE_LOCALE,
      useFactory: getLocale,
      deps: [Translator],
    },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class EditTemporadaTarifasComponent implements OnInit, AfterViewInit {
  loading = true;
  private ngUnsubscribe = new Subject();

  @Input() pkId: string;
  @Input() mode: Mode;
  @Input() modificar: boolean;

  editTemporadaForm: FormGroup;
  translation: any;

  readonly coresDisponiveis: Array<{ value: string; label: string; hex: string }> = [
    { value: "Blue", label: "Blue", hex: "#1976d2" },
    { value: "Red", label: "Red", hex: "#f44336" },
    { value: "Green", label: "Green", hex: "#4caf50" },
    { value: "Orange", label: "Orange", hex: "#ff9800" },
    { value: "Purple", label: "Purple", hex: "#9c27b0" },
    { value: "Black", label: "Black", hex: "#000000" },
    { value: "White", label: "White", hex: "#ffffff" },
  ];
  private readonly _colorNameToHex: Record<string, string> = this.coresDisponiveis.reduce(
    (acc, c) => {
      acc[c.value.toLowerCase()] = c.hex;
      return acc;
    },
    {} as Record<string, string>
  );

  /** Regex para código hex válido: #RGB, #RRGGBB ou #RRGGBBAA */
  private static readonly HEX_COLOR_REGEX = /^#([A-Fa-f0-9]{3}|[A-Fa-f0-9]{6}|[A-Fa-f0-9]{8})$/;

  static hexOrNamedColorValidator(control: AbstractControl): ValidationErrors | null {
    const v = (control.value ?? "").toString().trim();
    if (!v) return null;
    if (v.startsWith("#")) {
      return EditTemporadaTarifasComponent.HEX_COLOR_REGEX.test(v) ? null : { invalidHexColor: true };
    }
    return null;
  }

  /** Secuencias prohibidas en Descripción (bloqueadas por la API). */
  private static readonly DESCRIPCION_PROHIBIDAS = ['--', ';', '/*', '*/', '@@'];

  static descripcionCaracteresProhibidosValidator(control: AbstractControl): ValidationErrors | null {
    const v = (control.value ?? "").toString();
    if (!v) return null;
    const encontrado = EditTemporadaTarifasComponent.DESCRIPCION_PROHIBIDAS.find((seq) => v.includes(seq));
    return encontrado ? { descripcionCaracteresProhibidos: { secuencia: encontrado } } : null;
  }

  /** Elimina del texto las secuencias prohibidas por la API en Descripción. */
  static sanitizarDescripcion(valor: string): string {
    let s = (valor ?? "").toString();
    EditTemporadaTarifasComponent.DESCRIPCION_PROHIBIDAS.forEach((seq) => {
      s = s.split(seq).join("");
    });
    return s;
  }

  centrosSinAsignar = [];
  centrosAsignados = [];
  format = {
    add: "Añadir",
    remove: "Borrar",
    all: "Todos",
    none: "Ninguno",
    direction: DualListComponent.LTR,
    draggable: true,
    locale: "es",
  };

  listadoDias: string[] = [];
  private listadoDiasSet: Set<string> = new Set();
  mesesEntreFechas: MesInfo[] = [];
  mesesDoAnoVigente: MesInfo[] = [];
  useStaticColorForTest = false;
  private _cachedColorParaCalendario: string = "#1976d2";
  private isDraggingColor = false;
  @ViewChild("calendariosRoot") private calendariosRoot?: ElementRef<HTMLElement>;
  @ViewChild("pickerInicio") private pickerInicio?: MatDatepicker<Date>;
  @ViewChild("pickerFin") private pickerFin?: MatDatepicker<Date>;
  mesesSeleccionados: Set<string> = new Set();
  mesVisControls: Record<string, FormControl> = {};
  diasOcupados: Set<string> = new Set();
  loadingOcupados = false;
  private anoVigenteCache: number | null = null;
  private calendarioTouched = false;
  
  private diasDelMesCache: Map<string, number[]> = new Map();
  private diaOffsetCache: Map<string, number> = new Map();
  private fechaFormatCache: Map<string, string> = new Map();

  private rangoFechaInicioIso: string | null = null;
  private rangoFechaFinIso: string | null = null;

  private dragState: { active: boolean; mes: string; dia: number; mode: "add" | "remove" } = {
    active: false,
    mes: "",
    dia: 0,
    mode: "add",
  };

  constructor(
    private fb: FormBuilder,
    private translator: Translator,
    private servicioAPI: ConectarApiService,
    private panelService: PanelService,
    private gsCentros: GlobalServicCentros,
    private global: GlobalService,
    private snackvar_service: SnackbarInfoService,
    private httpErrorService: HttpErrorsService,
    private cdRef: ChangeDetectorRef
  ) {}

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  ngAfterViewInit(): void {
    this._applyCalendarioColorCssVar(this._cachedColorParaCalendario || "#1976d2");
  }

  private _flagFromApi(value: any): boolean {
    if (value === true) return true;
    if (value === false) return false;
    if (value === 1) return true;
    if (value === 0) return false;
    if (value == null) return false;
    const s = String(value).trim().toLowerCase();
    if (s === "1" || s === "true") return true;
    if (s === "0" || s === "false") return false;
    return false;
  }

  async ngOnInit(): Promise<void> {
    this.initializeTranslate();
    this.initializeForm();
    this.valuedChanged();
    await this.loadCentros();
    await this.manageForm(this.pkId, this.mode);
    this.loading = false;
    this.actualizarMesesEntreFechas();
    this.cdRef.detectChanges();
  }

  async loadCentros() {
    await this.gsCentros.getCentros();
  }

  initializeTranslate() {
    this.translation = this.translator.GetTranslations();
    this.format = {
      add: this.translation.Anadir || "Añadir",
      remove: this.translation.Borrar || "Borrar",
      all: this.translation.Todos || "Todos",
      none: this.translation.Ninguno || "Ninguno",
      direction: DualListComponent.LTR,
      draggable: true,
      locale: "es",
    };
  }

  initializeForm() {
    this.editTemporadaForm = this.fb.group({
      pkId: [""],
      Nombre: ["", [Validators.required, Validators.maxLength(100)]],
      Descripcion: ["", [Validators.maxLength(500), EditTemporadaTarifasComponent.descripcionCaracteresProhibidosValidator]],
      Color: ["Blue", [Validators.maxLength(9), EditTemporadaTarifasComponent.hexOrNamedColorValidator]],
      Activa: [false],
      PorDefecto: [false],
      FechaInicio: [null, Validators.required],
      FechaFin: [null, Validators.required],
    });
    this._cachedColorParaCalendario = "#1976d2";
  }

  valuedChanged() {
    this.editTemporadaForm.valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe(() => {
      this.panelService.setDiscardChanges(false);
    });
    this.editTemporadaForm.get("FechaInicio").valueChanges
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(() => {
        this.actualizarMesesEntreFechas();
        this.syncListadoDiasWithRango();
        this.cdRef.markForCheck();
        this.cdRef.detectChanges();
      });
    this.editTemporadaForm.get("FechaFin").valueChanges
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(() => {
        this.actualizarMesesEntreFechas();
        this.syncListadoDiasWithRango();
        this.cdRef.markForCheck();
        this.cdRef.detectChanges();
      });
    this.editTemporadaForm.get("Color").valueChanges
      .pipe(
        debounceTime(150),
        distinctUntilChanged(),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe((color) => {
        this._updateCachedColor(color);
        this.cdRef.markForCheck();
      });
  }

  private getRangoFechasNormalizado(): { inicio: moment.Moment; fin: moment.Moment } | null {
    const ini = this.editTemporadaForm?.get("FechaInicio")?.value;
    const fin = this.editTemporadaForm?.get("FechaFin")?.value;
    if (!ini || !fin) {
      this.rangoFechaInicioIso = null;
      this.rangoFechaFinIso = null;
      return null;
    }
    
    let start: moment.Moment | null = null;
    let end: moment.Moment | null = null;
    
    if (moment.isMoment(ini) && typeof (ini as any).clone === 'function') {
      start = (ini as moment.Moment).clone();
    } else if (ini instanceof Date) {
      start = moment(ini);
    } else if (typeof ini === 'string') {
      start = moment(ini, ['YYYY/MM/DD', 'YYYY/M/D', 'DD/MM/YYYY', 'D/M/YYYY', 'YYYY-MM-DD', 'DD-MM-YYYY'], true);
      if (!start.isValid() && /^\d{4}[\/\-]\d{1,2}[\/\-]\d{1,2}/.test(ini)) {
        start = moment(ini.replace(/\//g, '-'), 'YYYY-MM-DD', true);
      }
    } else {
      start = moment(ini);
    }
    if (moment.isMoment(fin) && typeof (fin as any).clone === 'function') {
      end = (fin as moment.Moment).clone();
    } else if (fin instanceof Date) {
      end = moment(fin);
    } else if (typeof fin === 'string') {
      end = moment(fin, ['YYYY/MM/DD', 'YYYY/M/D', 'DD/MM/YYYY', 'D/M/YYYY', 'YYYY-MM-DD', 'DD-MM-YYYY'], true);
      if (!end.isValid() && /^\d{4}[\/\-]\d{1,2}[\/\-]\d{1,2}/.test(fin)) {
        end = moment(fin.replace(/\//g, '-'), 'YYYY-MM-DD', true);
      }
    } else {
      end = moment(fin);
    }
    
    if (!start || !start.isValid() || !end || !end.isValid() || start.isAfter(end)) {
      this.rangoFechaInicioIso = null;
      this.rangoFechaFinIso = null;
      return null;
    }
    
    start = start.startOf("day");
    end = end.startOf("day");
    
    this.rangoFechaInicioIso = start.format("YYYY-MM-DD");
    this.rangoFechaFinIso = end.format("YYYY-MM-DD");
    return { inicio: start, fin: end };
  }

  private syncListadoDiasWithRango(options: { markDirty?: boolean } = {}): void {
    const { markDirty = true } = options;
    const rango = this.getRangoFechasNormalizado();
    if (!rango) return;

    const { inicio, fin } = rango;
    const inicioKey = inicio.format("YYYY-MM-DD");
    const finKey = fin.format("YYYY-MM-DD");
    const next = (this.listadoDias || []).filter((d) => {
      if (!d) return false;
      if (this.diasOcupados.has(d)) return false;
      return d >= inicioKey && d <= finKey;
    });

    next.sort();
    const prevKey = (this.listadoDias || []).slice().sort().join("|");
    const nextKey = next.join("|");
    if (prevKey === nextKey) return;

    this.listadoDias = [...next];
    this.listadoDiasSet = new Set(this.listadoDias);
    if (markDirty) {
      // listadoDias is not a form control, so we explicitly track changes.
      this.editTemporadaForm.markAsDirty();
    }
    this.cdRef.markForCheck();
  }

  actualizarMesesEntreFechas() {
    const ini = this.editTemporadaForm.get("FechaInicio").value;
    const fin = this.editTemporadaForm.get("FechaFin").value;
    
    this.getRangoFechasNormalizado();
    
    const mesesLabels = [
      "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
      "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
    ];
    this.mesesEntreFechas = [];
    const anoVigente = this.getAnoVigente();
    const anoMudou = this.anoVigenteCache !== anoVigente;
    
    if (anoMudou) {
      this.diasDelMesCache.clear();
      this.diaOffsetCache.clear();
      this.fechaFormatCache.clear();
    }
    
    const dozeMesesDoAno: MesInfo[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((mesNum) => ({
      mes: `${anoVigente}-${String(mesNum).padStart(2, "0")}`,
      anio: anoVigente,
      mesNum,
      label: mesesLabels[mesNum - 1] + " " + anoVigente,
    }));
    this.mesesDoAnoVigente = dozeMesesDoAno;
    if (ini && fin) {
      const start = moment(ini);
      const end = moment(fin);
      if (!start.isAfter(end)) {
        let cur = moment(start).startOf("month");
        while (cur.isSameOrBefore(end, "month")) {
          this.mesesEntreFechas.push({
            mes: cur.format("YYYY-MM"),
            anio: cur.year(),
            mesNum: cur.month() + 1,
            label: mesesLabels[cur.month()] + " " + cur.year(),
          });
          cur.add(1, "month");
        }
        this.cargarDiasOcupados();
      }
    }
    const chavesAno = dozeMesesDoAno.map((m) => m.mes);
    if (anoMudou) {
      this.mesVisControls = {};
    }
    for (const k of chavesAno) {
      this.getMesVisControl(k);
    }

    const rango = this.getRangoFechasNormalizado();
    if (rango) {
      for (const m of dozeMesesDoAno) {
        if (!this.isMesDentroDelRango(m.mes)) continue;
        const ctrl = this.getMesVisControl(m.mes);
        if (ctrl.value === false) {
          ctrl.setValue(true, { emitEvent: false });
        }
      }
    }

    this.mesesSeleccionados = new Set(chavesAno.filter((k) => this.mesVisControls[k]?.value !== false));
    this.anoVigenteCache = anoVigente;
    this.listadoDiasSet = new Set(this.listadoDias);
    this.cdRef.markForCheck();
  }

  getMesVisControl(mesKey: string): FormControl {
    if (!this.mesVisControls[mesKey]) {
      const ctrl = new FormControl(true);
      ctrl.valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe((val) => {
        if (val === false) this.mesesSeleccionados.delete(mesKey);
        else this.mesesSeleccionados.add(mesKey);
        this.cdRef.markForCheck();
      });
      this.mesVisControls[mesKey] = ctrl;
    }
    return this.mesVisControls[mesKey];
  }

  private parseFechaFormValue(val: any): moment.Moment | null {
    if (!val) return null;
    if (moment.isMoment(val) && val.isValid()) return val;
    if (val instanceof Date && !isNaN(val.getTime())) return moment(val);
    if (typeof val === "string") {
      const m = moment(val, ["YYYY/MM/DD", "DD/MM/YYYY", "YYYY-MM-DD", "DD-MM-YYYY"], true);
      return m.isValid() ? m : null;
    }
    return null;
  }

  private getAnoVigente(): number {
    const ini = this.editTemporadaForm?.get("FechaInicio")?.value;
    const parsed = this.parseFechaFormValue(ini);
    return parsed ? parsed.year() : moment().year();
  }

  get minFechaPicker(): Date {
    const baseYear = this.getAnoVigente();
    return moment({ year: baseYear - 2, month: 0, day: 1 }).startOf("day").toDate();
  }

  get maxFechaPicker(): Date {
    const baseYear = this.getAnoVigente();
    return moment({ year: baseYear + 2, month: 11, day: 31 }).endOf("day").toDate();
  }


  get startAtInicioPicker(): Date {
    const ini = this.editTemporadaForm?.get("FechaInicio")?.value;
    const parsed = this.parseFechaFormValue(ini);
    return parsed ? parsed.toDate() : moment().startOf("day").toDate();
  }

  get startAtFinPicker(): Date {
    const fin = this.editTemporadaForm?.get("FechaFin")?.value;
    const parsed = this.parseFechaFormValue(fin);
    return parsed ? parsed.toDate() : moment().startOf("day").toDate();
  }

  getMesesParaExibir(): MesInfo[] {
    if (this.mesesDoAnoVigente?.length) return this.mesesDoAnoVigente;
    const year = this.getAnoVigente();
    const mesesLabels = [
      "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
      "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
    ];
    return mesesLabels.map((nome, i) => ({
      mes: `${year}-${String(i + 1).padStart(2, "0")}`,
      anio: year,
      mesNum: i + 1,
      label: nome + " " + year,
    }));
  }

  getMesesCalendarioVisibles(): MesInfo[] {
    const base = this.mesesDoAnoVigente?.length ? this.mesesDoAnoVigente : this.getMesesParaExibir();
    return base.filter((m) => this.getMesVisControl(m.mes).value !== false);
  }

  tieneRango(): boolean {
    if (!this.editTemporadaForm) return false;
    const ini = this.editTemporadaForm.get("FechaInicio")?.value;
    const fin = this.editTemporadaForm.get("FechaFin")?.value;
    return !!(ini && fin);
  }

  isMesDentroDelRango(mesKey: string): boolean {
    const ini = this.editTemporadaForm.get("FechaInicio").value;
    const fin = this.editTemporadaForm.get("FechaFin").value;
    const inicioParsed = this.parseFechaFormValue(ini);
    const finParsed = this.parseFechaFormValue(fin);
    if (!inicioParsed || !finParsed) return false;
    const inicio = inicioParsed.clone().startOf("month");
    const finRango = finParsed.clone().endOf("month");
    const m = moment(mesKey + "-01", "YYYY-MM-DD", true);
    return m.isValid() && m.isSameOrAfter(inicio) && m.isSameOrBefore(finRango);
  }

  isDiaDentroDelRango(mesKey: string, dia: number): boolean {
    if (!this.rangoFechaInicioIso || !this.rangoFechaFinIso) return false;
    const fecha = this.formatFechaKey(mesKey, dia);
    return fecha >= this.rangoFechaInicioIso && fecha <= this.rangoFechaFinIso;
  }

  cargarDiasOcupados() {
    const ini = this.editTemporadaForm.get("FechaInicio").value;
    const fin = this.editTemporadaForm.get("FechaFin").value;
    if (!ini || !fin) return;
    this.loadingOcupados = true;
    const fechaInicio = this.formatFechaApi(ini);
    const fechaFin = this.formatFechaApi(fin);
    const currentPkId = this.editTemporadaForm.get("pkId").value;
    this.servicioAPI
      .getTemporadaTarifasEntreFechas(fechaInicio, fechaFin)
      .pipe(first())
      .subscribe(
        (data) => {
          this.diasOcupados = new Set();
          const listado = data?.DatosResult?.listado || data?.DatosResult?.Lista || data?.listado || data?.Lista || [];
          (listado || []).forEach((item: any) => {
            const diaRaw = item.Dia ?? item.dia;
            let dia: string | null = null;
            
            if (diaRaw) {
              if (typeof diaRaw === "string") {
                if (/^\d{4}-\d{2}-\d{2}$/.test(diaRaw)) {
                  dia = diaRaw;
                } else {
                  const parsed = moment(diaRaw, ['YYYY/MM/DD', 'YYYY-MM-DD', 'DD/MM/YYYY', 'DD-MM-YYYY'], true);
                  if (parsed.isValid()) {
                    dia = parsed.format("YYYY-MM-DD");
                  }
                }
              } else if (diaRaw instanceof Date) {
                const parsed = moment(diaRaw);
                if (parsed.isValid()) {
                  dia = parsed.format("YYYY-MM-DD");
                }
              }
            }
            
            const tempIdRaw = item.TemporadaTId ?? item.temporadaTId ?? item.TemporadaId ?? 0;
            const tempIdNum = Number(String(tempIdRaw).trim());
            const currentPkIdNum = currentPkId != null && String(currentPkId).trim() !== ""
              ? Number(String(currentPkId).trim())
              : NaN;

            if (
              dia &&
              Number.isFinite(tempIdNum) &&
              tempIdNum !== 0 &&
              (!Number.isFinite(currentPkIdNum) || tempIdNum !== currentPkIdNum)
            ) {
              this.diasOcupados.add(dia);
            }
          });
          this.loadingOcupados = false;
          this.syncListadoDiasWithRango({ markDirty: false });
          this.cdRef.detectChanges();
        },
        () => {
          this.loadingOcupados = false;
          this.cdRef.detectChanges();
        }
      );
  }

  getMesesSeleccionados() {
    return (this.mesesEntreFechas || []).filter((m) => this.mesesSeleccionados.has(m.mes));
  }

  trackByMesKey(_index: number, m: { mes: string; anio: number; mesNum: number; label: string }): string {
    return m.mes;
  }

  onColorPickerChange(event: Event) {
    const val = (event.target as HTMLInputElement).value;
    if (!val) return;
    
    this._updateCachedColor(val);
    
    if (this.isDraggingColor) {
      return;
    } else {
      const ctrl = this.editTemporadaForm.get("Color");
      if (ctrl.value !== val) {
        ctrl.setValue(val, { emitEvent: true });
      }
      this.cdRef.markForCheck();
    }
  }

  onColorPickerMouseDown(event: MouseEvent) {
    this.isDraggingColor = true;
  }

  onColorPickerMouseUp(event: MouseEvent) {
    if (this.isDraggingColor) {
      const val = (event.target as HTMLInputElement)?.value;
      if (val) {
        const ctrl = this.editTemporadaForm.get("Color");
        if (ctrl.value !== val) {
          ctrl.setValue(val, { emitEvent: true });
        }
        this._updateCachedColor(val);
        this.cdRef.markForCheck();
      }
      this.isDraggingColor = false;
    }
  }

  private _applyCalendarioColorCssVar(color: string): void {
    const el = this.calendariosRoot?.nativeElement;
    if (!el) return;
    el.style.setProperty("--temporada-color", color || "#1976d2");
  }

  private _updateCachedColor(color: string | null): void {
    const trimmed = (color || "").trim();
    let result = "#1976d2";
    if (!trimmed) {
      result = "#1976d2";
    } else if (this._colorNameToHex[trimmed.toLowerCase()]) {
      result = this._colorNameToHex[trimmed.toLowerCase()];
    } else if (trimmed.startsWith("#") && /^#[0-9A-Fa-f]{3,8}$/.test(trimmed)) {
      result = trimmed;
    } else if (trimmed.startsWith("rgb")) {
      result = trimmed;
    } else if (/^[0-9A-Fa-f]{3,8}$/.test(trimmed)) {
      result = "#" + trimmed;
    }
    if (this._cachedColorParaCalendario !== result) {
      this._cachedColorParaCalendario = result;
      this._applyCalendarioColorCssVar(result);
    }
  }

  get colorParaCalendario(): string {
    return this._cachedColorParaCalendario;
  }


  get colorSelectValue(): string {
    const raw = (this.editTemporadaForm?.get("Color")?.value || "").toString().trim();
    if (!raw) return "Blue";
    const lower = raw.toLowerCase();
    const match = this.coresDisponiveis.find((c) => c.value.toLowerCase() === lower);
    return match ? match.value : "__custom__";
  }

  get isCustomColor(): boolean {
    return this.colorSelectValue === "__custom__";
  }

  onColorSelectChange(value: string): void {
    const ctrl = this.editTemporadaForm?.get("Color");
    if (!ctrl) return;
    if (value === "__custom__") {
      const current = (ctrl.value || "").toString().trim();
      const keep = current.startsWith("#") ? current : this._cachedColorParaCalendario || "#1976d2";
      ctrl.setValue(keep, { emitEvent: true });
      return;
    }
    ctrl.setValue(value, { emitEvent: true });
  }

  getDiasDelMes(mesKey: string): number[] {
    if (this.diasDelMesCache.has(mesKey)) {
      return this.diasDelMesCache.get(mesKey)!;
    }
    const parts = mesKey.split("-").map(Number);
    const y = parts[0], m = parts[1];
    if (isNaN(y) || isNaN(m) || m < 1 || m > 12) {
      return [];
    }
    const dateStr = `${y}-${String(m).padStart(2, "0")}-01`;
    const m2 = moment(dateStr, "YYYY-MM-DD", true);
    const dias = m2.isValid() ? m2.daysInMonth() : 31;
    const result = Array.from({ length: dias }, (_, i) => i + 1);
    this.diasDelMesCache.set(mesKey, result);
    return result;
  }

  getDiaOffset(mesKey: string): number {
    if (this.diaOffsetCache.has(mesKey)) {
      return this.diaOffsetCache.get(mesKey)!;
    }
    const parts = mesKey.split("-").map(Number);
    const y = parts[0], m = parts[1];
    if (isNaN(y) || isNaN(m) || m < 1 || m > 12) {
      return 0;
    }
    const dateStr = `${y}-${String(m).padStart(2, "0")}-01`;
    const m2 = moment(dateStr, "YYYY-MM-DD", true);
    const result = m2.isValid() ? m2.isoWeekday() - 1 : 0;
    this.diaOffsetCache.set(mesKey, result);
    return result;
  }
  

  private formatFechaKey(mesKey: string, dia: number): string {
    const key = `${mesKey}-${dia}`;
    if (this.fechaFormatCache.has(key)) {
      return this.fechaFormatCache.get(key)!;
    }
    const fechaStr = `${mesKey}-${String(dia).padStart(2, "0")}`;
    const fecha = moment(fechaStr, "YYYY-MM-DD", true).format("YYYY-MM-DD");
    this.fechaFormatCache.set(key, fecha);
    return fecha;
  }

  isDiaOcupado(mesKey: string, dia: number): boolean {
    const fecha = this.formatFechaKey(mesKey, dia);
    return this.diasOcupados.has(fecha);
  }

  isDiaSeleccionado(mesKey: string, dia: number): boolean {
    const fecha = this.formatFechaKey(mesKey, dia);
    return this.listadoDiasSet.has(fecha);
  }
  
  trackByDiaKey(_index: number, dia: number): number {
    return dia;
  }

  @HostListener("document:pointerup")
  onDocumentMouseUp() {
    this.dragState.active = false;
  }

  private addDia(mesKey: string, dia: number): void {
    const fechaStr = `${mesKey}-${String(dia).padStart(2, "0")}`;
    const fecha = moment(fechaStr, "YYYY-MM-DD", true).isValid()
      ? moment(fechaStr, "YYYY-MM-DD", true).format("YYYY-MM-DD") : fechaStr;
    const ocupado = this.diasOcupados.has(fecha);
    const yaIncluido = this.listadoDiasSet.has(fecha);
    if (ocupado || yaIncluido) {
      return;
    }
    this.listadoDiasSet.add(fecha);
    this.listadoDias.push(fecha);
  }

  private removeDia(mesKey: string, dia: number): void {
    const fechaStr = `${mesKey}-${String(dia).padStart(2, "0")}`;
    const fecha = moment(fechaStr, "YYYY-MM-DD", true).isValid()
      ? moment(fechaStr, "YYYY-MM-DD", true).format("YYYY-MM-DD") : fechaStr;
    const idx = this.listadoDias.indexOf(fecha);
    if (idx >= 0) {
      this.listadoDias.splice(idx, 1);
      this.listadoDiasSet.delete(fecha);
    }
  }

  private aplicarDia(mesKey: string, dia: number, mode: "add" | "remove"): void {
    this.calendarioTouched = true;
    const fechaStr = `${mesKey}-${String(dia).padStart(2, "0")}`;
    const fecha = moment(fechaStr, "YYYY-MM-DD", true).isValid()
      ? moment(fechaStr, "YYYY-MM-DD", true).format("YYYY-MM-DD") : fechaStr;
    if (mode === "add") this.addDia(mesKey, dia);
    else this.removeDia(mesKey, dia);
    this.panelService.setDiscardChanges(false);
    this.editTemporadaForm.markAsDirty();
  }

  marcarDesdeDiaHastaFinMes(mesKey: string, dia: number): void {
    this.calendarioTouched = true;
    const parts = mesKey.split("-").map(Number);
    const y = parts[0], m = parts[1];
    if (isNaN(y) || isNaN(m) || m < 1 || m > 12) return;
    const dateStr = `${y}-${String(m).padStart(2, "0")}-01`;
    const m2 = moment(dateStr, "YYYY-MM-DD", true);
    const ultimoDia = m2.isValid() ? m2.daysInMonth() : 31;
    for (let d = dia; d <= ultimoDia; d++) {
      if (this.isDiaDentroDelRango(mesKey, d)) this.addDia(mesKey, d);
    }
    this.panelService.setDiscardChanges(false);
  }

  private lastPointerDown = { mes: "", dia: 0, t: 0 };

  private handleDiaPress(mesKey: string, dia: number) {
    const ocupado = this.isDiaOcupado(mesKey, dia);
    const enRango = this.isDiaDentroDelRango(mesKey, dia);
    if (ocupado || !enRango) return;
    this.lastPointerDown = { mes: mesKey, dia, t: Date.now() };
    const estaSeleccionado = this.isDiaSeleccionado(mesKey, dia);
    this.aplicarDia(mesKey, dia, estaSeleccionado ? "remove" : "add");
    this.dragState = { active: true, mes: mesKey, dia, mode: estaSeleccionado ? "remove" : "add" };
  }

  onDiaClick(mesKey: string, dia: number) {
    const ocupado = this.isDiaOcupado(mesKey, dia);
    const enRango = this.isDiaDentroDelRango(mesKey, dia);
    const skipPorPointer = this.lastPointerDown.mes === mesKey && this.lastPointerDown.dia === dia && Date.now() - this.lastPointerDown.t < 300;
    if (ocupado || !enRango) return;
    if (skipPorPointer) return;
    const estaSeleccionado = this.isDiaSeleccionado(mesKey, dia);
    this.aplicarDia(mesKey, dia, estaSeleccionado ? "remove" : "add");
  }

  onDiaPointerDown(mesKey: string, dia: number, _event?: PointerEvent) {
    this.handleDiaPress(mesKey, dia);
  }

  onDiaMouseDown(mesKey: string, dia: number) {
    const recentlyHandled =
      this.lastPointerDown.mes === mesKey &&
      this.lastPointerDown.dia === dia &&
      Date.now() - this.lastPointerDown.t < 300;
    if (recentlyHandled) return;
    this.handleDiaPress(mesKey, dia);
  }

  onDiaMouseEnter(mesKey: string, dia: number) {
    if (!this.dragState.active) return;
    if (mesKey !== this.dragState.mes) return;
    if (this.isDiaOcupado(mesKey, dia) || !this.isDiaDentroDelRango(mesKey, dia)) return;
    this.aplicarDia(mesKey, dia, this.dragState.mode);
  }

  async manageForm(pkId: string, mode: Mode) {
    if (mode === "I") {
      this.centrosAsignados = [];
      this.centrosSinAsignar = (this.gsCentros.tipoCentros || []).filter(
        (c: any) => c.Activo === "True" || c.Activo === true
      );
      // Defaults explícitos para "Añadir"
      this.editTemporadaForm.patchValue({
        pkId: "",
        Activa: false,
        PorDefecto: false,
      });
      return;
    }
    if (pkId) {
      await this.cargarTemporada(pkId, mode);
    }
  }

  async cargarTemporada(pkId: string, mode: Mode) {
    try {
      const paginator = { page: 1, pagelements: 1, orderby: "pkId", ordertype: "ASC" };
      const data = await this.servicioAPI.getTemporadaTarifasAsync(paginator, [], pkId);
      const listado = data?.DatosResult?.listado || data?.DatosResult?.Lista || [];
      const item = Array.isArray(listado) && listado.length ? listado[0] : null;
      if (item) {
        const colorValue = item.Color || "#1976d2";
        
        const parseFecha = (fecha: any): Date | null => {
          if (!fecha) return null;
          const formats = ["YYYY/MM/DD", "YYYY-MM-DD", "DD/MM/YYYY", "DD-MM-YYYY"];
          for (const fmt of formats) {
            const parsed = moment(fecha, fmt, true);
            if (parsed.isValid()) {
              return parsed.toDate();
            }
          }
          const autoParsed = moment(fecha);
          return autoParsed.isValid() ? autoParsed.toDate() : null;
        };
        
        this.editTemporadaForm.patchValue({
          pkId: item.pkId,
          Nombre: item.Nombre || "",
          Descripcion: (item.Descripcion || "").trim(),
          Color: colorValue,
          Activa: this._flagFromApi(item.Activa),
          PorDefecto: this._flagFromApi(item.PorDefecto),
          FechaInicio: parseFecha(item.FechaInicio),
          FechaFin: parseFecha(item.FechaFin),
        });
        this._updateCachedColor(colorValue);
        if (mode === "D") {
          this.editTemporadaForm.get("pkId").setValue("");
          this.editTemporadaForm.get("Color").setValue("Blue");
          this._updateCachedColor("Blue");
          this.listadoDias = [];
          this.listadoDiasSet = new Set();
          this.calendarioTouched = false;
        } else {
          const dias = item.listadoDias || item.ListadoDias || [];
          this.listadoDias = Array.isArray(dias)
            ? dias
                .map((d: any) => {
                  const raw = typeof d === "string" ? d : d?.Dia;
                  if (!raw || raw.trim() === "") return null;
                  const formats = ["YYYY/MM/DD", "YYYY-MM-DD", "DD/MM/YYYY", "DD-MM-YYYY"];
                  for (const fmt of formats) {
                    const parsed = moment(raw, fmt, true);
                    if (parsed.isValid()) {
                      return parsed.format("YYYY-MM-DD");
                    }
                  }
                  const autoParsed = moment(raw);
                  return autoParsed.isValid() ? autoParsed.format("YYYY-MM-DD") : null;
                })
                .filter((d: string | null): d is string => d !== null && d !== "")
            : [];
          this.listadoDiasSet = new Set(this.listadoDias);
          this.calendarioTouched = this.listadoDias.length > 0;
        }
        const centrosIds = item.CentrosIds || item.centrosIds || "";
        this.centrosAsignados = this.gsCentros.daTiposCentros({
          CentrosIds: centrosIds,
          centrosIds: centrosIds,
        }) || [];
        const all = (this.gsCentros.tipoCentros || []).filter(
          (c: any) => c.Activo === "True" || c.Activo === true
        );
        // IMPORTANTE: o customan-dual-list (angular-dual-listbox) consegue derivar
        // "disponíveis" vs "atribuídos" a partir do source + destination.
        // Se enviarmos o source já subtraindo os atribuídos e, por exemplo,
        // todos os centros estiverem atribuídos, o source fica vazio e o componente
        // pode não renderizar a lista da direita corretamente (itens ficam "invisíveis").
        // Portanto mantemos o source como a lista completa de centros ativos.
        this.centrosSinAsignar = all;
        this.actualizarMesesEntreFechas();
        this.syncListadoDiasWithRango({ markDirty: false });
      }
    } catch (error) {
      this.httpErrorService.identificarErrores(error);
    }
  }

  validateFields(field: string): boolean {
    const c = this.editTemporadaForm.get(field);
    return c && c.invalid && (c.dirty || c.touched);
  }

  getErrorMessage(field: string): string {
    const c = this.editTemporadaForm.get(field);
    if (!c || !c.errors) return "";
    if (c.errors.required) return this.translation?.CampoRequerido || "Campo requerido";
    if (c.errors.maxlength) return (this.translation?.MaxCaracteres || "Máx.") + " " + c.errors.maxlength.requiredLength;
    if (c.errors.invalidHexColor) return this.translation?.ColorHexInvalido || "Introduzca un color hexadecimal válido (#RGB, #RRGGBB o #RRGGBBAA).";
    if (c.errors.descripcionCaracteresProhibidos) {
      const seq = c.errors.descripcionCaracteresProhibidos.secuencia;
      const msg = this.translation?.DescripcionCaracteresProhibidos
        || ("No se permiten los caracteres: -- ; " + "/* */" + " @@. Carácter bloqueado: ");
      return msg + `"${seq}"`;
    }
    return "";
  }

  /** Bloquea en el campo Descripción las secuencias prohibidas por la API: -- ; slash-star slash-star @@ */
  onDescripcionInput(event: Event): void {
    const input = event.target as HTMLTextAreaElement;
    const valor = input.value ?? "";
    const sanitizado = EditTemporadaTarifasComponent.sanitizarDescripcion(valor);
    if (sanitizado !== valor) {
      const ctrl = this.editTemporadaForm.get("Descripcion");
      if (ctrl) {
        ctrl.setValue(sanitizado, { emitEvent: true });
        input.value = sanitizado;
      }
    }
  }

  /** Restringe el input del campo Color (modo personalizado) a solo caracteres hexadecimales. */
  onHexColorInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = (input.value || "").trim();
    const hasHash = value.startsWith("#");
    const rest = hasHash ? value.slice(1) : value;
    const hexOnly = rest.replace(/[^0-9A-Fa-f]/g, "");
    const maxLen = 8;
    const truncated = hexOnly.slice(0, maxLen);
    const newValue = hasHash ? "#" + truncated : (truncated ? "#" + truncated : "");
    if (newValue !== value) {
      const ctrl = this.editTemporadaForm.get("Color");
      if (ctrl) {
        ctrl.setValue(newValue, { emitEvent: true });
        input.value = newValue;
      }
    }
  }

  private formatFechaApi(value: any): string {
    if (value == null || value === "") return "";
    const m = moment(value);
    return m.isValid() ? m.format("YYYY/MM/DD") : "";
  }

 
  private _normalizeDiaIso(value: any): string | null {
    if (value == null) return null;
    if (typeof value !== "string") {
      const m = moment(value);
      return m.isValid() ? m.format("YYYY-MM-DD") : null;
    }
    const s = value.trim();
    if (!s) return null;
    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
    if (/^\d{4}\/\d{2}\/\d{2}$/.test(s)) {
      const m = moment(s, "YYYY/MM/DD", true);
      return m.isValid() ? m.format("YYYY-MM-DD") : null;
    }
    const m = moment(s, ["YYYY-MM-DD", "YYYY/MM/DD", moment.ISO_8601], true);
    return m.isValid() ? m.format("YYYY-MM-DD") : null;
  }

  submit() {
    this.editTemporadaForm.markAllAsTouched();
    if (this.editTemporadaForm.invalid) return;
    const f = this.editTemporadaForm.value;
    const descripcion = EditTemporadaTarifasComponent.sanitizarDescripcion(
      (f.Descripcion || "").replace(/\r\n/g, "\n").replace(/\r/g, "\n").trim()
    );
    const rawColor = (f.Color || "").trim();
    let colorToSend = rawColor;
    const isNamedColor = !!(colorToSend && this._colorNameToHex[colorToSend.toLowerCase()]);
    if (!colorToSend) {
      colorToSend = "Blue";
    } else if (!isNamedColor) {
      if (colorToSend && !colorToSend.startsWith("#") && !colorToSend.startsWith("rgb")) {
        colorToSend = "#" + colorToSend;
      }
    }
    const CentrosIds = this.gsCentros.obtenercentrosAsociadosconOrden(this.centrosAsignados);

    const diasConflitantes = (this.listadoDias || []).filter((d) => {
      const iso = this._normalizeDiaIso(d);
      return !!(iso && this.diasOcupados?.has(iso));
    });
    if (diasConflitantes.length) {
      const msg =
        (this.translation?.FechasOcupadas || "Las siguientes fechas ya están vinculadas a otra temporada:") +
        " " +
        diasConflitantes
          .slice()
          .sort()
          .slice(0, 12)
          .map((d) => {
            const iso = this._normalizeDiaIso(d);
            return iso ? moment(iso, "YYYY-MM-DD").format("YYYY/MM/DD") : String(d);
          })
          .join(", ") +
        (diasConflitantes.length > 12 ? "..." : "");
      this.snackvar_service.openSnackBar(msg, "", "red-snackbar");
      return;
    }

    const body: any = {
      Nombre: (f.Nombre || "").trim(),
      Descripcion: descripcion,
      Color: colorToSend,
      Activa: f.Activa ? "1" : "0",
      PorDefecto: f.PorDefecto ? "1" : "0",
      FechaInicio: f.FechaInicio ? this.formatFechaApi(f.FechaInicio) : null,
      FechaFin: f.FechaFin ? this.formatFechaApi(f.FechaFin) : null,
      CentrosIds: CentrosIds || "",
      listadoDias: [...this.listadoDias].sort().map((d) => this.formatFechaApi(d)),
    };
    if (this.mode === "U" && f.pkId) {
      body.pkId = String(f.pkId);
    }
    this.loading = true;
    const save$ =
      this.mode === "U"
        ? this.servicioAPI.updTemporadaTarifas(body)
        : this.servicioAPI.insTemporadaTarifas(body);

    save$
      .pipe(first())
      .subscribe(
        (data) => {
          this.loading = false;
          if (data?.DatosResult != null) {
            this.snackvar_service.openSnackBar(
              this.translation?.DatosGuardadosCorrectamente || "Datos guardados correctamente",
              "",
              "green-snackbar"
            );
            this.panelService.setSavePanel(null);
            this.panelService.setClosePanel(null);
          } else if (data?.Mensajes?.length) {
            this.snackvar_service.openSnackBar(
              data.Mensajes[0].DescripcionMensaje,
              "",
              "red-snackbar"
            );
          }
        },
        (error) => {
          this.loading = false;
          this.httpErrorService.identificarErrores(error);
        }
      );
  }

  destroy() {
    this.panelService.setDiscardChanges(true);
    this.panelService.setClosePanel(null);
  }

  discard() {
    this.manageForm(this.pkId, this.mode);
  }
}
